module.exports = __webpack_public_path__ + "img/np.d01e1cf8.png";